import React from "react";
import styled, { css } from "styled-components";
import { arrayOf, shape, string } from "prop-types";
import car from "icons/car.svg";
import gb from "icons/gb.png";
import nonsmoker from "icons/nonsmoker.png";

const ICON_STYLES = css`
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: 12px 50%;
  padding-left: 38px;
`;

const StyledProfileDataInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

const StyledLabel = styled.div`
  color: ${props => props.theme.colors.midGrey};
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 2px;
  height: 30px;
`;

const StyledValues = styled.div`
  height: 38px;
  width: 500px;
  overflow: hidden;
`;

const StyledValue = styled.div`
  display: inline-block;
  background: ${props =>
    props.theme.colors[
      props.extraStyles ? props.extraStyles.background : "whiteSmoke"
    ]};
  color: ${props =>
    props.theme.colors[
      props.extraStyles ? props.extraStyles.colour : "midGrey"
    ]};
  font-weight: 600;
  border-radius: 23px;
  font-size: 17px;
  margin-right: 15px;
  margin-bottom: 5px;
  height: 36px;
  line-height: 35px;
  padding: 0 15px;

  &.licenseddriver,
  &.carowner {
    background-image: url(${car});
    ${ICON_STYLES}
  }

  &.english {
    background-image: url(${gb});
    ${ICON_STYLES}
  }

  &.nonsmoker {
    background-image: url(${nonsmoker});
    ${ICON_STYLES}
  }
`;

const ProfileDataInfo = ({ id, label, values, extraStyles }) => {
  return (
    <StyledProfileDataInfo id={id}>
      <StyledLabel>{label}</StyledLabel>
      <StyledValues>
        {values.map((value, index) => (
          <StyledValue
            key={value}
            className={value.replace(/\s+/g, "").toLowerCase()}
            extraStyles={extraStyles ? extraStyles[index] : null}
          >
            {value}
          </StyledValue>
        ))}
      </StyledValues>
    </StyledProfileDataInfo>
  );
};

ProfileDataInfo.propTypes = {
  extraStyles: arrayOf(shape({ background: string, colour: string })),
  id: string.isRequired,
  label: string.isRequired,
  values: arrayOf(string)
};

ProfileDataInfo.defaultProps = {
  extraStyles: null,
  values: []
};

export default ProfileDataInfo;
